import { ReactNode } from 'react'
import * as React from 'react'

import MaterializedPopUp from '../../molecules/PopUp/MaterializedPopUp/MaterializedPopUp'
import MaterializedFooter from '../../organisms/footer/MaterializedFooter'
import MaterializedHeader from '../../organisms/header/MaterializedHeader'

interface RootLayoutProps {
  children: ReactNode
}

const RootLayout = ({ children }: RootLayoutProps) => {
  return (
    <>
      <MaterializedHeader />
      <MaterializedPopUp />
      <main>{children}</main>
      <MaterializedFooter />
    </>
  )
}

export default RootLayout
